import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        // {
        //   name: "添加",
        //   type: "success",
        //   icon: "document-add"
        // },
        // {
        //   name: "修改",
        //   type: "primary",
        //   icon: "edit"
        // },
        // {
        //   name: "删除",
        //   type: "danger",
        //   icon: "delete"
        // },
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
        regulators: null, // 招标监管部门
        tenderReference: null, // 招标编号
        announcementId: null, // 招标公告编号
        registrationId: null, // 招标登记编号
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          minWidth: "300",
          isShow: true,
          fixed: true,
        },
        {
          label: "状态",
          slotName: "state",
          minWidth: "100",
          fixed: true,
        },
        {
          label: "招标组织形式",
          prop: "tenderMethodFlag",
          minWidth: "120",
        },
        {
          label: "标段",
          prop: "section",
          minWidth: "80",
        },
        {
          label: "招标人",
          prop: "tenderCorpName",
          minWidth: "250",
        },
        {
          label: "招标代理机构",
          prop: "tenderAgentOrganName",
          minWidth: "250",
        },
        {
          label: "变更后的投标有效期（日历天）",
          prop: "tenderValidityChangeDay",
          minWidth: "250",
        },
        {
          label: "原投标有效期（日历天）",
          prop: "oldTenderValidityDay",
          minWidth: "200",
        },
        {
          label: "招标投标监管部门",
          prop: "regulators",
          minWidth: "300",
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      // 温馨提示
      tipList: [
      /* {
         type: "text",
         text: "（1）当状态为\"招标人确认中\"时，招标人请点击项目名称进入详情后进行操作。",
       }*/
     ],
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/tenderValidityChange/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 甲方确认标志
      let tenderSigFlag = "";
      // 甲方确认状态不为空
      if(e.val.tenderSignedState != "" && e.val.tenderSignedState != null){
        // 设置为是
        tenderSigFlag = "1";
      }
      // 跳转详情页面
      this.$router.push({path: "/tenderValidityChangeDetail", query: { id: e.val.id, isTenderSignature: tenderSigFlag, type: "details" }});
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 跳转详情页面
      this.$router.push({path: "/tenderValidityChangeDetail", query: { type: "insert" }});
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          // 如果是自行招标
          if(this.multipleSelection[0].tenderMethod != '1'){
            // 则验证若是招标人则不能修改操作
            if(this.multipleSelection[0].tenderCorpFlag == '01'){
              // 提示，并清除选中数据
              this.$alert("该项目为委托招标请直接点击项目进入详情进行查看，不能修改项目数据。", "warning").then(() => {
                // 清除选中数据
                this.$refs.list.$refs.multipleTable.clearSelection();
              });
              return false;
            }
          }
          // 状态名称
          let stateName = "";
          // 如果是提交状态
          if(this.multipleSelection[0].state == 'tj'){
            stateName = '提交';
            // 甲方确认编号不为空
            if(this.multipleSelection[0].tenderSignedId != '' && this.multipleSelection[0].tenderSignedId != null){
              // 如果是招标人确认中
              if(this.multipleSelection[0].tenderSignedState == 'tj'){
                stateName = '招标人确认中';
              }
            }
          }
          // 如果是通过
          else if(this.multipleSelection[0].state == 'tg'){
            stateName = '通过';
          }
          // 判断状态不为保存或者退回
          if(this.multipleSelection[0].state != 'bc' && this.multipleSelection[0].state != 'th'){
            // 提示，并清除选中数据
            this.$alert('该项目当前状态为“' + stateName + '”，不能修改！', "warning").then(() => {
              // 清除选中数据
              this.$refs.list.$refs.multipleTable.clearSelection();
            });
            return false;
          }
          // 跳转详情页面
          this.$router.push({path: "/tenderValidityChangeDetail", query: {id:this.multipleSelection[0].id, type:"update"}});
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 状态
        let visible = true;
        // 是否为甲方
        let tenderCorpFlag = "";
        // 招标组织形式
        let tenderMethod = "";
        // 遍历勾选
        for(const index in this.multipleSelection ){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
          // 判断状态为提交或者通过
          if(this.multipleSelection[index].state == 'tj' || this.multipleSelection[index].state == 'tg'){
            // 设置false
            visible = false;
          }
          // 如果招标组织形式不是 自行组织
          if(this.multipleSelection[index].tenderMethod != '1'){
            // 则验证若是招标人则不能修改操作
            if(this.multipleSelection[index].tenderCorpFlag == '01'){
              // 设置是否为甲方
              tenderCorpFlag = this.multipleSelection[index].tenderCorpFlag;
              // 设置招标组织形式
              tenderMethod = this.multipleSelection[index].tenderMethod;
              // 跳出循环
              break;
            }
          }
        }
        // 如果招标组织形式不是 自行组织
        if(tenderMethod != '1') {
          // 则验证若是招标人则不能修改操作
          if (tenderCorpFlag == '01') {
            // 提示，并清除选中数据
            this.$alert("该项目为委托招标请联系招标代理做删除操作。", "warning").then(() => {
              // 清除选中数据
              this.$refs.list.$refs.multipleTable.clearSelection();
            });
            return false;
          }
        }
        // 状态
        if (!visible) {
          // 提示，并清除选中数据
          this.$alert("该项目信息已核验通过或者已提交，无法进行删除或修改操作！", "warning");
          return;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/tenderValidityChange/delete", {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 获取一览表格数据
            this.fun_GetList();
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
